// should be the same as in launchDarkly UI flag 'key' value
export enum LaunchDarklyFlags {
  FE_TEST = 'lmn-pro-fe-test',
  CUSTOM_SUPPORT_ACCOUNT_ACCESS = 'lp-454-customer-support-account-access',
  ADMIN_LIST = 'lp-85-admin-list',
  SAGE_SALESFORCE_INTEGRATION = 'sage-salesforce-integration',
}
